import FastMarquee from 'react-fast-marquee';

const items = ['Tax Preparation', 'Tax Planning', 'Fractional CFO', 'Chapel Hill, NC'];

export default function Marquee() {
  return (
    <section data-testid="marquee-section" className="py-12 border-b border-navy/10 bg-cream overflow-hidden" aria-hidden="true">
      <FastMarquee speed={18} gradient={false}>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl md:text-6xl text-outline-navy whitespace-nowrap px-10">{item}</span>
            <span className="inline-block w-2.5 h-2.5 bg-gold rotate-45" />
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
